import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Scrollefec = () => {
	const { hash } = useLocation();

	const scrollToElement = useCallback(() => {
		if (hash) {
			const target = document.querySelector(hash);
			if (target) {
				const yOffset = -300; // Negative offset
				const yPosition =
					target.getBoundingClientRect().top +
					window.pageYOffset +
					yOffset;
				window.scrollTo({ top: yPosition, behavior: 'smooth' });
			}
		}
	}, [hash]);

	useEffect(() => {
		// Slight delay to ensure DOM is fully rendered
		const timer = setTimeout(scrollToElement, 100);
		return () => clearTimeout(timer);
	}, [hash, scrollToElement]);

	return <div id='reference'></div>;
};

export default Scrollefec;
